import { reflect } from '@effector/reflect';
import { TextInput } from '@mantine/core';
import { combine } from 'effector';
import { useUnit } from 'effector-react';
import { $t, translated } from 'shared/lib';
import { playerPageModel } from '../../model';
import cls from './player-page-info.module.scss';

const NameField = reflect({
	view: TextInput,
	bind: {
		value: playerPageModel.$player.map((player) => player?.name ?? ''),
		label: translated('player-registry.table-columns.name'),
		readOnly: true,
	},
});

const AccountField = reflect({
	view: TextInput,
	bind: {
		value: playerPageModel.$player.map((player) => player?.account?.name ?? ''),
		label: translated('player-registry.table-columns.account'),
		readOnly: true,
	},
});

const CashdeskField = reflect({
	view: TextInput,
	bind: {
		value: playerPageModel.$player.map((player) => player?.cashdesk?.name ?? ''),
		label: translated('player-registry.table-columns.cashdesk'),
		readOnly: true,
	},
});

const DeviceField = reflect({
	view: TextInput,
	bind: {
		value: playerPageModel.$player.map((player) => player?.device?.name ?? ''),
		label: translated('player-registry.table-columns.device'),
		readOnly: true,
	},
});

const GameField = reflect({
	view: TextInput,
	bind: {
		value: playerPageModel.$player.map((player) => player?.game?.title ?? ''),
		label: translated('player-registry.table-columns.game'),
		readOnly: true,
	},
});

const CurrencyField = reflect({
	view: TextInput,
	bind: {
		value: playerPageModel.$player.map((player) => player?.currency ?? ''),
		label: translated('player-registry.table-columns.currency'),
		readOnly: true,
	},
});

const BalanceField = reflect({
	view: TextInput,
	bind: {
		value: playerPageModel.$player.map((player) => (player ? String(player.balance) : '')),
		label: translated('player-registry.table-columns.balance'),
		readOnly: true,
	},
});

const StatusField = reflect({
	view: TextInput,
	bind: {
		value: combine([playerPageModel.$player, $t], ([player, t]) => {
			if (!player) {
				return '';
			}

			return player.isConnected
				? t('player-registry.status.active')
				: t('player-registry.status.not-active');
		}),
		label: translated('player-registry.table-columns.status'),
		readOnly: true,
	},
});

export const PlayerPageInfo = () => {
	const player = useUnit(playerPageModel.$player);

	if (!player) {
		return null;
	}

	return (
		<div className={cls.playerPageInfo}>
			<NameField />
			<AccountField />
			<CashdeskField />
			<DeviceField />
			<GameField />
			<CurrencyField />
			<BalanceField />
			<StatusField />
		</div>
	);
};
